import React from 'react';

const Masthead = () => {
   return (
      <section className="relative bg-white py-12 md:py-16 lg:py-24 overflow-hidden">
         <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:pl-[210px] lg:pr-[60px] relative">
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
               {/* Image Section - Affichée en premier sur mobile */}
               <div className="w-full lg:w-1/2 flex justify-center items-start order-first lg:order-last">
                  <div className="relative w-full max-w-md lg:max-w-lg">
                     <img
                        src="/home-8/hero/image.png"
                        alt="Online learning"
                        className="w-full h-auto rounded-lg"
                     />
                     {/* Decorative elements */}
                     <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-orange-500/20 rounded-full -z-10"></div>
                     <div className="absolute -top-6 -right-6 w-24 h-24 bg-purple-500/20 rounded-full -z-10"></div>
                  </div>
               </div>

               {/* Content Section - Affichée en second sur mobile */}
               <div className="w-full lg:w-1/2 order-last lg:order-first">
                  <div className="max-w-lg mx-auto lg:mx-0">
                     <h1 className="text-3xl sm:text-4xl font-bold text-dark-1 dark:text-white leading-tight mb-6">
                        Devenez un Maker certifié en quelques mois
                     </h1>
                     <p className="text-base sm:text-lg text-gray-700 dark:text-gray-300 mb-8">
                        Un parcours intensif hybride (présentiel + en ligne) pour acquérir les compétences du futur
                     </p>

                     {/* Buttons */}
                     <div className="flex flex-wrap gap-4 mb-8">
                        <a href="https://app.gonextmaker.com/auth/login" className="px-6 py-3 sm:px-8 sm:py-3 bg-red-4 text-white font-medium rounded-full transition-colors
                duration-300 hover:bg-white hover:text-red-4 border-2 border-red-4 text-sm sm:text-base">
                           voir nos programmes
                        </a>
                     </div>

                     {/* Stats Section - Modifiée pour être plus compacte et alignée */}
                     <div className="grid grid-cols-3 gap-4 sm:gap-6">
                        <div className="flex flex-col items-start text-start">
                           <div className="bg-white pl-0 p-3 rounded-lg mb-2">
                              <img className="w-5 h-5 sm:w-6 sm:h-6" src="/home-8/hero/icons/1.svg" alt="Design" />
                           </div>
                           <div className="text-xs sm:text-sm font-medium text-dark-1 dark:text-white leading-tight">
                              Design
                           </div>
                        </div>

                        <div className="flex flex-col items-start text-start">
                           <div className="bg-white pl-0 p-3 rounded-lg mb-2">
                              <img className="w-5 h-5 sm:w-6 sm:h-6" src="/home-8/hero/icons/2.svg" alt="Fabrication numérique" />
                           </div>
                           <div className="text-xs sm:text-sm font-medium text-dark-1 dark:text-white leading-tight">
                              Fabrication numérique
                           </div>
                        </div>

                        <div className="flex flex-col items-start text-start">
                           <div className="bg-white pl-0 p-3 rounded-lg mb-2">
                              <img className="w-5 h-5 sm:w-6 sm:h-6" src="/home-8/hero/icons/3.svg" alt="Electronique et programmation" />
                           </div>
                           <div className="text-xs sm:text-sm font-medium text-dark-1 dark:text-white leading-tight">
                              Electronique et programmation
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default Masthead;